import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import ColorWrapper, { WithColor } from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';

import { dashboardOverviewDateRangeLabels } from './constants';
import { DashboardOverviewDateRange } from '@reducers/v2/dashboard/types';

import { useManageDashboardOverviewHeaderDateRangePicker } from './hooks/useManageDashboardOverviewHeaderDateRangePicker';
import { BULLET } from '@v2/pages/common/constants/base.constants';
import DashboardOverviewDateRangeMoreSelector from './components/DashboardOverviewDateRangeMoreSelector';
import { DASHBOARD_PRESS_HOVER_BG_COLOR } from '@v2/pages/dashboard/common/constants/colors';

interface DashboardOverviewDateRangePickerProps extends WithColor {}

const DashboardOverviewHeaderDateRangePicker: FC<DashboardOverviewDateRangePickerProps> = ({ C }) => {
  const { selectedDateRange, onSelectDateRange } = useManageDashboardOverviewHeaderDateRangePicker();
  const entries = Object.entries(dashboardOverviewDateRangeLabels) as [DashboardOverviewDateRange, string][];

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {!isPhone &&
        entries.map(([dateRange, dateRangeLabel]) => {
          const isSelected = dateRange === selectedDateRange;

          return (
            <View style={{flexDirection: 'row', alignItems: 'center', gap: scale(4)}} key={dateRange}>
              <TouchableElement onPress={() => onSelectDateRange(dateRange)}>
                {({ boxStyle, pressHoverColor }) => (
                  <View
                    style={[
                      boxStyle,
                      {
                        paddingVertical: scale(4),
                        paddingHorizontal: scale(10),
                        borderRadius: scale(8),
                        backgroundColor: C(isSelected ? 'Background/Light/Secondary' : pressHoverColor(DASHBOARD_PRESS_HOVER_BG_COLOR)),
                      },
                    ]}
                  >
                    <Text style={[font['Button 1'], { color: C(isSelected ? 'System/Light/Blue' : 'Label/Light/Tertiary'), }]}>
                      {i18n.t(dateRangeLabel)}
                    </Text>
                  </View>
                )}
              </TouchableElement>
              <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{BULLET}</Text>
            </View>
          );
        })}
      <DashboardOverviewDateRangeMoreSelector selectedDateRange={selectedDateRange} onSelectDateRange={onSelectDateRange} />
    </View>
  );
};

export default ColorWrapper(DashboardOverviewHeaderDateRangePicker);
